<!-- 记录汇总 -->
<template>
    <div>
        <el-dialog title="分类统计设置" :visible.sync="dialogTableVisible" v-if="dialogTableVisible" width="520px">
            <div class="dis">
                <div class="totalBox">
                    <el-divider>分类选择</el-divider>
                    <div class="checkBox">
                        <el-checkbox-group v-model="strSelect" size="mini">
                            <el-checkbox v-for="(item,index) in stringField" :key="index" :label="item.fieldShow" border></el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="totalBox" style="margin-left: 20px;">
                    <el-divider>汇总选择</el-divider>
                    <div class="checkBox">
                        <el-checkbox-group v-model="numSelect" size="mini">
                            <el-checkbox name="checkName" v-for="(key,i) in numberField" :key="i" :label="key.fieldShow" border>
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogTableVisible = false">取 消</el-button>
                <el-button type="primary" @click="sendDataAction">确 定</el-button>
            </div>
        </el-dialog>
        <summaryReport ref="summaryReport"></summaryReport>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
    name: "recordSummary",
    props: ["actionData"],
    data() {
        //这里存放数据
        return {
            dialogTableVisible: false,
            multipleSelection: [],
            orderData: [],
            fileIds: [],
            fileType: false,
            printSource: '',
            strSelect: [],
            numSelect: [],
            numberField: [],
            stringField: [],
            list: [],
            selString: [],
            selNumber: [],
            dialogTableVisible1: false,
            allFieldList: [],
            dataShow: [],
            totalField: [],
            dateField: [],
            excelData: [],
            rpcName: ''
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        sendDataAction() {
            // 初始化数据
            this.selString = []
            this.selNumber = []
            this.totalField = []
            this.dateField = []

            // 精确匹配选择的字段
            this.stringField.forEach(key => {
                if (this.strSelect.includes(key.fieldShow)) {
                    this.selString.push(key)
                }
            })

            this.numberField.forEach(key => {
                if (this.numSelect.includes(key.fieldShow)) {
                    this.selNumber.push(key)
                }
            })

            const accKeys = []
            const searchKeys = []

            // 收集字段键名
            this.selString.forEach(item => {
                searchKeys.push(item.fieldEntity)
                if (item.fieldType == 'date') {
                    this.dateField.push(item.fieldEntity)
                }
            })

            this.selNumber.forEach(item => {
                accKeys.push(item.fieldEntity)
            })

            // 深拷贝原始数据避免修改源数据
            const resultList = JSON.parse(JSON.stringify(this.list))

            // 处理日期字段格式化
            resultList.forEach(item => {
                this.dateField.forEach(keys => {
                    if (item[keys] != null && item[keys] !== "") {
                        item[keys] = this.$common.getLocalTime(item[keys])
                    }
                })
            })

            // 初始化计数器
            resultList.forEach(item => {
                item.total = 1
            })

            // 优化数据聚合逻辑
            const res = resultList.reduce((pre, cur) => {
                // 查找是否已存在相同分组的记录
                const findIndex = pre.findIndex(item => {
                    return searchKeys.every(key => {
                        // 处理null、undefined和空字符串的等价性
                        const preValue = item[key];
                        const curValue = cur[key];

                        if (preValue === null || preValue === undefined || preValue === "") {
                            return curValue === null || curValue === undefined || curValue === "";
                        }
                        return preValue === curValue;
                    });
                });

                if (findIndex > -1) {
                    // 如果找到，则累加数值字段
                    const existingItem = pre[findIndex];
                    accKeys.forEach(key => {
                        // 确保数值类型正确后再累加
                        const curValue = parseFloat(cur[key]) || 0;
                        const existingValue = parseFloat(existingItem[key]) || 0;
                        existingItem[key] = existingValue + curValue;
                    });
                    // 累加计数
                    existingItem.total += 1;
                } else {
                    // 如果未找到，初始化数值字段
                    const newItem = { ...cur };
                    accKeys.forEach(key => {
                        newItem[key] = parseFloat(newItem[key]) || 0;
                    });
                    pre.push(newItem);
                }

                return pre;
            }, []);

            this.dataShow = res;

            // 合并字段列表
            this.allFieldList = [...this.selString, ...this.selNumber];

            // 收集合计字段
            this.allFieldList.forEach(key => {
                if (key.isTotal == 1) {
                    this.totalField.push(key.fieldEntity);
                }
            });

            // 处理数值格式化
            this.dataShow.forEach(item => {
                this.allFieldList.forEach(field => {
                    if (field.fieldType == 'number') {
                        // 确保数值格式化前是有效数字
                        const value = parseFloat(item[field.fieldEntity]);
                        if (!isNaN(value)) {
                            item[field.fieldEntity] = this.$common.getDecimalInfo(3, value);
                        } else {
                            item[field.fieldEntity] = this.$common.getDecimalInfo(3, 0);
                        }
                    }
                });
            });
            let reportInfo = {
                allFieldList: this.allFieldList,
                dataShow: this.dataShow,
                rpcName: this.rpcName,
                count: this.list.length,
                type: 'hb'
            }

            this.$refs.summaryReport.openBox(reportInfo)
            // this.dialogTableVisible1 = true
        },

        openBox(data) {
            console.log(data);
            this.numberField = data.numberField
            this.stringField = data.stringField
            console.log(this.stringField)
            this.list = data.list
            this.numSelect = []
            this.strSelect = []
            this.rpcName = data.rpcName + '汇总'
            this.dialogTableVisible = true

        },
        tableRowClassName({
            row,
            rowIndex
        }) {
            if (row.color) return row.color;
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.printSource = sessionStorage.getItem('printSource').replace(/\"/g, "");
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.totalBox {
    width: 230px;
}

.dis {
    display: flex;
}

.checkBox {
    border: 1px solid #dcdfe6;
    padding: 10px;
}

::v-deep .el-checkbox.is-bordered.el-checkbox--mini {
    width: 210px;
    margin-left: 0 !important;
}
</style>